<div class="related-activities">
    <h3 *ngIf="relatedData.title" class="title">{{ relatedData.title }}</h3>
    <div class="cards-container"
        *ngFor="let row of cardRows" [ngClass]="row.quantityClass">
        <finder-button-card *ngFor="let card of row.cards"
            class="card"
            [imageData]="card.image"
            [title]="card.title"
            [ariaLabel]="card.copy[0]"
            [link]="card.link"
            [copy]="card.copy[0]">
        </finder-button-card>
    </div>
</div>
